// client/src/components/marketer/project/modals/ProductModal.js
import React, { useState } from 'react';
import { API_URL } from '../constants';
import AlertModal from './AlertModal';
import '../../../../styles/marketer/modals/ProductModal.css';

export default function ProductModal({ open, onClose, projectId, serviceType, initialProduct, onSaved }) {
  const [local, setLocal] = useState(initialProduct || {});
  const [saving, setSaving] = useState(false);
  const [alertMsg, setAlertMsg] = useState('');
  if (!open) return null;
  const set = (k, v) => setLocal(prev => ({ ...prev, [k]: v }));

  const save = async () => {
    if (!projectId) { 
      setAlertMsg('먼저 1단계를 저장해주세요.'); 
      return; 
    }

    // 필수 항목 검증
    if (serviceType === 'delivery') {
      if (!local.name?.trim()) { setAlertMsg('제품명을 입력해주세요.'); return; }
      if (!local.price || Number(local.price) <= 0) { setAlertMsg('제품 가격을 입력해주세요.'); return; }
      if (!local.url?.trim()) { setAlertMsg('제품 판매처(URL)를 입력해주세요.'); return; }
    }
    if (serviceType === 'purchase') {
      if (!local.name?.trim()) { setAlertMsg('제품명을 입력해주세요.'); return; }
      if (!local.price || Number(local.price) <= 0) { setAlertMsg('제품 가격을 입력해주세요.'); return; }
      if (!local.purchasePlace?.trim()) { setAlertMsg('제품 구매처(URL)를 입력해주세요.'); return; }
    }
    if (serviceType === 'visit') {
      if (!local.placeName?.trim()) { setAlertMsg('장소/서비스명을 입력해주세요.'); return; }
      if (!local.placeAddress?.trim()) { setAlertMsg('장소의 주소 혹은 서비스 URL을 입력해주세요.'); return; }
    }
    if (serviceType === 'free') {
      if (!local.customTitle?.trim()) { setAlertMsg('제목을 입력해주세요.'); return; }
      if (!local.customDesc?.trim()) { setAlertMsg('상세 설명을 입력해주세요.'); return; }
    }

    setSaving(true);
    try {
      const body = {};
      if (serviceType === 'delivery') { body.name = local.name; body.price = Number(local.price || 0); body.url = local.url; }
      if (serviceType === 'purchase') { body.name = local.name; body.price = Number(local.price || 0); body.purchasePlace = local.purchasePlace; }
      if (serviceType === 'visit')    { body.placeName = local.placeName; body.placeAddress = local.placeAddress; }
      if (serviceType === 'free')     { body.customTitle = local.customTitle; body.customDesc = local.customDesc; }

      const res = await fetch(`${API_URL}/api/marketer/mybiz/projects/${encodeURIComponent(projectId)}/product`, {
        method: 'PATCH', credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
      const j = await res.json().catch(()=>({}));
      if (!res.ok || !j?.ok) throw new Error(j?.message || '저장 실패');

      onSaved(local);
      onClose();
    } catch(e) { 
      setAlertMsg(e.message || '저장 실패'); 
    }
    setSaving(false);
  };

  return (
    <>
      <div className="product-modal mbm-overlay">
        <div className="product-modal__content mbm">
          <button onClick={onClose} aria-label="close" className="product-modal__close mbm-close">×</button>
          <div className="product-modal__header">
            <div className="product-modal__title mbm-title">광고할 제품/장소/서비스 정보 입력</div>
            <div className="product-modal__subtitle">
              {serviceType === 'delivery' && '제품 제공 방식'}
              {serviceType === 'purchase' && '제품 미제공 방식'}
              {serviceType === 'visit' && '장소(서비스) 광고 방식'}
              {serviceType === 'free' && '자율 형식'}
            </div>
          </div>

          {serviceType === 'delivery' && (
            <div className="product-modal__form">
              <div className="product-modal__field">
                <label className="product-modal__label">제품명(필수)</label>
                <input className="product-modal__input" placeholder="제품명을 입력해주세요" value={local.name || ''} onChange={e=>set('name', e.target.value)} />
              </div>
              <div className="product-modal__field">
                <label className="product-modal__label">제품 가격(숫자만)(필수)</label>
                <input 
                  className="product-modal__input" 
                  placeholder="숫자만 입력" 
                  type="text" 
                  inputMode="numeric"
                  value={local.price === 0 ? '' : local.price || ''} 
                  onChange={e => {
                    const value = e.target.value.replace(/[^0-9]/g, '');
                    set('price', value);
                  }} 
                />
              </div>
              <div className="product-modal__field">
                <label className="product-modal__label">제품 판매처(URL)(필수)</label>
                <input className="product-modal__input" placeholder="https://example.com/product" value={local.url || ''} onChange={e=>set('url', e.target.value)} />
                <div className="product-modal__hint">제품의 판매처(주소 혹은 URL link)를 입력해주세요.</div>
              </div>
            </div>
          )}
          {serviceType === 'purchase' && (
            <div className="product-modal__form">
              <div className="product-modal__field">
                <label className="product-modal__label">제품명(필수)</label>
                <input className="product-modal__input" placeholder="제품명을 입력해주세요" value={local.name || ''} onChange={e=>set('name', e.target.value)} />
              </div>
              <div className="product-modal__field">
                <label className="product-modal__label">제품 가격(숫자만)(필수)</label>
                <input 
                  className="product-modal__input" 
                  placeholder="숫자만 입력" 
                  type="text" 
                  inputMode="numeric"
                  value={local.price === 0 ? '' : local.price || ''} 
                  onChange={e => {
                    const value = e.target.value.replace(/[^0-9]/g, '');
                    set('price', value);
                  }} 
                />
              </div>
              <div className="product-modal__field">
                <label className="product-modal__label">제품 구매처(URL)(필수)</label>
                <input className="product-modal__input" placeholder="예: https://example.com/product" value={local.purchasePlace || ''} onChange={e=>set('purchasePlace', e.target.value)} />
                <div className="product-modal__hint">제품의 판매처(주소 혹은 URL link)를 입력해주세요.</div>
              </div>
            </div>
          )}
          {serviceType === 'visit' && (
            <div className="product-modal__form">
              <div className="product-modal__field">
                <label className="product-modal__label">장소/서비스명 (필수)</label>
                <input className="product-modal__input" placeholder="광고할 장소/서비스의 이름을 입력해주세요" value={local.placeName || ''} onChange={e=>set('placeName', e.target.value)} />
              </div>
              <div className="product-modal__field">
                <label className="product-modal__label">장소의 주소 혹은 서비스 URL (필수)</label>
                <input className="product-modal__input" placeholder="상세 주소를 입력해주세요" value={local.placeAddress || ''} onChange={e=>set('placeAddress', e.target.value)} />
                <div className="product-modal__hint">인플루언서가 방문할 정확한 위치를 입력해주세요</div>
              </div>
            </div>
          )}
          {serviceType === 'free' && (
            <div className="product-modal__form">
              <div className="product-modal__field">
                <label className="product-modal__label">제목 <span className="product-modal__required">*</span></label>
                <input className="product-modal__input" placeholder="제품/서비스/장소/브랜드명 등" value={local.customTitle || ''} onChange={e=>set('customTitle', e.target.value)} />
              </div>
              <div className="product-modal__field">
                <label className="product-modal__label">상세 설명 <span className="product-modal__required">*</span></label>
                <textarea className="product-modal__textarea" placeholder="URL 또는 상세 설명을 입력해주세요" rows={5} value={local.customDesc || ''} onChange={e=>set('customDesc', e.target.value)} />
                <div className="product-modal__hint">인플루언서가 광고할 내용을 자유롭게 입력해주세요</div>
              </div>
            </div>
          )}

          <div className="product-modal__actions mbm-foot">
            <button type="button" onClick={onClose} disabled={saving} className="product-modal__button product-modal__button--cancel mb-btn mb-btn-secondary">취소</button>
            <button type="button" onClick={save} disabled={saving} className="product-modal__button product-modal__button--submit mb-btn mb-btn-primary">
              {saving ? '저장 중...' : '확인'}
            </button>
          </div>
        </div>
      </div>
      
      <AlertModal 
        open={!!alertMsg} 
        onClose={() => setAlertMsg('')} 
        message={alertMsg} 
      />
    </>
  );
}